import styled from "styled-components";
import { theme } from "../../../Customization/Theme";

export const ModelStyleWrapper = styled.div`
    // background-color: ${theme.palette.default.lightGrey};
    // padding: 0 1rem;
`